import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ProgressBar, {
      mode: "indeterminate",
      class: "kn-progress-bar",
      hidden: !_ctx.load,
      "data-test": "related-docs-progress-bar"
    }, null, 8, ["hidden"]),
    _createVNode(_component_DataTable, {
      value: _ctx.relatedDocumentsList,
      selection: _ctx.selectedProduct1,
      "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedProduct1 = $event)),
      selectionMode: "single",
      onRowSelect: _ctx.onDocumentSelect,
      paginator: true,
      loading: _ctx.load,
      rows: 20,
      class: "p-datatable-sm kn-table",
      dataKey: "id",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
      filterDisplay: "menu",
      globalFilterFields: _ctx.menuConfigurationRelatedDocumentsDescriptor.globalFilterFields,
      rowsPerPageOptions: [10, 15, 20],
      responsiveLayout: "stack",
      breakpoint: "960px",
      currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' }),
      "data-test": "related-documents-list"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              type: "text",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              placeholder: _ctx.$t('common.search'),
              badge: "0",
              "data-test": "search-input"
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menuConfigurationRelatedDocumentsDescriptor.columns, (col) => {
          return (_openBlock(), _createBlock(_component_Column, {
            field: col.field,
            header: _ctx.$t(col.header),
            key: col.field,
            style: _ctx.menuConfigurationRelatedDocumentsDescriptor.table.column.style,
            sortable: true,
            class: "kn-truncated"
          }, {
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                class: "p-column-filter"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            body: _withCtx((slotProps) => [
              _createVNode("span", {
                title: slotProps.data[col.field]
              }, _toDisplayString(slotProps.data[col.field]), 9, ["title"])
            ]),
            _: 2
          }, 1032, ["field", "header", "style"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "selection", "onRowSelect", "loading", "filters", "globalFilterFields", "currentPageReportTemplate"])
  ], 64))
}